import { isDefined } from 'class-validator';
import { SystemConfigType } from 'src/configs/system.config';
import { InterestsTypes } from 'src/enums/interests.enum';
import { LanguagePreferenceEnum } from 'src/enums/language.enum';
import { SensorCategoryType, SensorType } from 'src/enums/nginr-type.enum';
import { MediaType } from 'src/enums/surfer.enums';
import { LayoutViewType, UserGuideTab } from 'src/enums/user.enum';
import { User } from 'src/types/user.type';

/*
Indicates whether the data in the config was read successfully or is missing from the config
*/
export const isConfigDisabled = (cfg: string) => {
  if (!isDefined(cfg)) return true;
  if (cfg.startsWith('{{')) return true;
  if (cfg === 'true') return false;
  return true;
};

/* Keeps the list of interests read from the config */
export const getInterestWhitelist = (config: SystemConfigType['interests']): InterestsTypes[] => {
  const result: InterestsTypes[] = [];
  Object.entries(config).forEach(([key, value]) => {
    if (value) result.push(InterestsTypes[key as keyof typeof InterestsTypes]);
  });
  return result;
};

/* Keeps the list of media types read from the config */
export const getMediaTypesWhitelist = (config: SystemConfigType['mediaTypes']): MediaType[] => {
  const result: MediaType[] = [];
  Object.entries(config).forEach(([key, value]) => {
    if (value) result.push(MediaType[key as keyof typeof MediaType]);
  });
  return result;
};

/* Keeps the list of sensor types read from the config */
export const getSensorTypesWhitelist = (config: SystemConfigType['sensorTypes']): SensorType[] => {
  const result: SensorType[] = [];
  Object.entries(config).forEach(([key, value]) => {
    if (value) result.push(SensorType[key as keyof typeof SensorType]);
  });
  return result;
};

/* Keeps the list of sensor category types read from the config */
export const getSensorCategoryTypesWhitelist = (
  config: SystemConfigType['sensorCategoryTypes'],
): SensorCategoryType[] => {
  const result: SensorCategoryType[] = [];
  Object.entries(config).forEach(([key, value]) => {
    if (value) result.push(SensorCategoryType[key as keyof typeof SensorCategoryType]);
  });
  return result;
};

export const getLayoutWhitelist = (config: LayoutViewType): LayoutViewType => {
  return config;
};

export const getProductName = (layout: UserGuideTab) => {
  switch (layout) {
    case UserGuideTab.sc3:
      return 'SC3';
    case UserGuideTab['system-login']:
      return 'SAMA';
    case UserGuideTab.nginr:
      return 'NGINR';
    case UserGuideTab['hymots-g']:
      return 'HYMOTS-G';
    case UserGuideTab.etecube:
      return 'ETECUBE';
    default:
      return '';
  }
};
export const getPreferredLanguage = (): string => {
  const userStr = sessionStorage.getItem('user');
  if (!userStr) return '';
  try {
    const user: User = JSON.parse(userStr);
    return user?.preferredLanguage ?? 'en';
  } catch (error) {
    console.log('error', error);
    return 'en';
  }
};

export const getFontFamily = (layout: LayoutViewType, lang: LanguagePreferenceEnum) => {
  // const userPreferredLanguage = getPreferredLanguage();

  switch (layout) {
    case LayoutViewType.SC3_LAYOUT:
      return 'Urbanist';
    case LayoutViewType.SAMA_RED_LAYOUT:
      return lang === 'ar' ? 'Lusail' : 'Urbanist';
    case LayoutViewType.NGINR_LAYOUT:
      return 'Urbanist';
    case LayoutViewType.SAMA_BLACK_LAYOUT:
      return lang === 'ar' ? 'Lusail' : 'Urbanist';
    case LayoutViewType.FULL:
      return 'Urbanist';

    default:
      return 'Urbanist';
  }
};
